/* ============================================================
   Vibe Boutique — Homepage Interactive JS
   Loaded ONLY on homepage (template.name == 'index')
   Vanilla JS ES2020, no dependencies
   ============================================================ */

(function () {
  'use strict';

  /* ── Config ── */
  var BRANDS = [
    'Hugo Boss',
    'Tommy Hilfiger',
    'Calvin Klein',
    'Armani',
    'Jack & Jones',
    'HUGO'
  ];

  var MARQUEE_BRANDS = [
    'Hugo Boss', 'Tommy Hilfiger', 'Calvin Klein',
    'Armani', 'Jack & Jones', 'HUGO',
    'Pepe Jeans', 'Tom Tailor', 'Marc O\'Polo', 'Lacoste'
  ];

  /* ─────────────────────────────────────────────────
     1. CUSTOM CURSOR (desktop pointer devices only)
  ───────────────────────────────────────────────── */
  function initCursor() {
    /* Only on true pointer devices — skip touch/mobile */
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var dot = document.createElement('div');
    dot.className = 'vb-cursor';
    document.body.appendChild(dot);

    document.addEventListener('mousemove', function (e) {
      dot.style.left = e.clientX + 'px';
      dot.style.top  = e.clientY + 'px';
    }, { passive: true });

    /* Hide cursor when leaving window */
    document.addEventListener('mouseleave', function () { dot.style.opacity = '0'; });
    document.addEventListener('mouseenter', function () { dot.style.opacity = '1'; });
  }

  /* ─────────────────────────────────────────────────
     2. HERO OVERLAY
     Server-rendered în snippets/vb-hero-overlay.liquid
     (SEO/AEO: conținutul există în HTML, nu se mai injectează din JS)
  ───────────────────────────────────────────────── */

  /* ─────────────────────────────────────────────────
     3. BRAND WORD ROTATION
     Fade cross-dissolve, 2.5s interval
  ───────────────────────────────────────────────── */
  function initBrandRotation() {
    var el = document.getElementById('vb-brand-word');
    if (!el) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var idx = 0;
    setInterval(function () {
      el.style.opacity = '0';
      setTimeout(function () {
        idx = (idx + 1) % BRANDS.length;
        el.textContent = BRANDS[idx];
        el.style.opacity = '1';
      }, 420);
    }, 2500);
  }

  /* ─────────────────────────────────────────────────
     4. BRAND MARQUEE BAND (injected after hero)
  ───────────────────────────────────────────────── */
  function injectBrandsMarquee() {
    var hero = document.querySelector('[id^="Hero-"]');
    if (!hero) return;

    /* Build the scrolling items (doubled for seamless loop) */
    var items = MARQUEE_BRANDS.concat(MARQUEE_BRANDS);
    var html = items.map(function (b) {
      return '<span>' + b.replace(/&/g, '&amp;') + '</span>';
    }).join('');

    var marquee = document.createElement('div');
    marquee.className = 'vb-brands-marquee';
    marquee.setAttribute('aria-hidden', 'true');
    marquee.innerHTML = '<div class="vb-brands-track">' + html + '</div>';

    /* Insert immediately AFTER the hero shopify-section */
    var heroSection = hero.closest('.shopify-section') || hero.parentNode;
    if (heroSection.nextSibling) {
      heroSection.parentNode.insertBefore(marquee, heroSection.nextSibling);
    } else {
      heroSection.parentNode.appendChild(marquee);
    }
  }

  /* ─────────────────────────────────────────────────
     6. SCROLL REVEAL (for sections below hero)
  ───────────────────────────────────────────────── */
  function initScrollReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var targets = document.querySelectorAll('[data-vb-reveal]');
    if (!targets.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vb-reveal-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    targets.forEach(function (el) { observer.observe(el); });
  }

  /* ─────────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────────── */
  function init() {
    /* Guard: only run if hero is on page */
    if (!document.querySelector('[id^="Hero-"]')) return;

    initCursor();
    initBrandRotation();
    injectBrandsMarquee();
    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
